import React from 'react';
import { stencilPrinterName as tooltip } from 'pu-data/Tooltips';
import TextComponent from './TextComponent';

const StencilPrinterName = (props) => {
  const name = 'printer_type';
  const {
    label, inputId, required, groupName, children, onChangeParameter, errorMessage,
  } = props
  const onChange = (e) => onChangeParameter(name, e.target.value);
  const { parameters } = props
  return (
    <TextComponent
      label={label}
      name={name}
      inputId={inputId}
      value={parameters[name] || ''}
      required={required}
      onChange={onChange}
      tooltip={tooltip}
      ignoreOnQuote
      groupName={groupName}
      errorMessage={errorMessage}>
      {children}
    </TextComponent>
  );
};

StencilPrinterName.defaultProps = {
  required: true,
  inputId: 'printer-type',
  label: 'Printer Name',
};

export default StencilPrinterName;
